import * as Sentry from '@sentry/browser';

import { config } from '../../config';

// if (import.meta.env.PROD) {
const release = config.serviceVersion;
const environment = config.serviceEnvironment;
const dsn = config.sentryToken;

Sentry.init({
    dsn,
    environment,
    release,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
    tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
});
// }

// export const reportErrorToSentry = import.meta.env.PROD
//     ? (...args: [any, any?]) => Sentry.captureException(...args)
//     : () => undefined;

export const reportErrorToSentry = (...args: [any, any?]) => Sentry.captureException(...args);
